import 'reflect-metadata'; // Import only once
import Vue from 'vue'
import '@/hooks'
import IdleVue from 'idle-vue'
import store from '@/store'
import router from '@/router'
import '@/app.container'
import { appBoot, countHub } from '@/services';
import App from '@/App.vue'
import '@/registerServiceWorker'
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import { config, library, dom } from '@fortawesome/fontawesome-svg-core';
import {
  faAsterisk, faUserShield, faSignalSlash,
  faSignal, faPlus, faMinus,
  faCheckCircle, faEdit, faExclamationTriangle,
  faHome, faLocationCircle, faCalendarAlt,
  faUser, faInboxOut, faSave,
  faBan, faEllipsisH, faCheck,
  faSync, faTimesCircle, faShare,
  faFileUpload, faRedo, faQuestionCircle,
  faQuestion, faMobileAlt, faPlusSquare, faCodeMerge, faTrashAlt
} from '@fortawesome/pro-solid-svg-icons';
import {
  faDumpster, faUtensils, faClipboardListCheck,
  faChevronDoubleLeft, faChevronDoubleRight, faAppleCrate,
  faUtensilsAlt, faCalculatorAlt, faTimesOctagon,
  faSitemap, faChartNetwork, faVial
} from "@fortawesome/pro-duotone-svg-icons";
import { faCircle } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import McDatetime from "vue-ctk-date-time-picker";
import "./vue-ctk-date-time-picker.css";
import componentRegistry from '@/components';
import VOffline from 'v-offline';
import VueFormWizard from "@/components/form-wizard";
import '@/components/form-wizard/assets/wizard.scss';
import moment from 'moment';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';

// Do not run locally
if(process.env.NODE_ENV !== 'development') {
  const appInsightConnectionString = getAppinsightConnection();
  //grabs the appInsightConnection by environment
  function getAppinsightConnection() {
    const appSettings = require('../../appsettings.json');
    var appInsightConnection = appSettings.ApplicationInsights.Development;
    if (process.env.NODE_ENV === 'test')
      appInsightConnection = appSettings.ApplicationInsights.Test;
    if (process.env.NODE_ENV === 'staging')
      appInsightConnection = appSettings.ApplicationInsights.Staging;
    if (process.env.NODE_ENV === 'production')
      appInsightConnection = appSettings.ApplicationInsights.Production;
    return appInsightConnection;
  }

  const appInsights = new ApplicationInsights({
    config: {
      connectionString: appInsightConnectionString
    }
  })

  appInsights.loadAppInsights();
  appInsights.trackPageView();
}

moment.defaultFormat = 'YYYY-MM-DD HH:mm';
moment.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

appBoot.activate();
const eventsHub = new Vue();

// fontawesome configuration
dom.watch(); // this will kick off the replacement of i to svg tags and configure a MutationObserver
config.autoReplaceSvg = 'nest'; // tell Font Awesome to nest the  SVG element under the I element.
config.autoAddCss = true;
config.searchPseudoElements = true; // Searches for elements with a Font Awesome CSS family-name and content property and replaces with inline SVG
//config.showMissingIcons = true; // if an icon cannot be found show an animated “missing” icon in its place

library.add(faAsterisk, faUserShield, faSignalSlash,
  faSignal, faPlus, faMinus,
  faUtensils, faDumpster, faCheckCircle,
  faCircle, faEdit, faClipboardListCheck,
  faChevronDoubleLeft, faChevronDoubleRight, faExclamationTriangle,
  faAppleCrate, faUtensilsAlt, faHome,
  faLocationCircle, faCalendarAlt, faUser,
  faInboxOut, faCalculatorAlt, faSave,
  faBan, faTimesOctagon, faSitemap, faChartNetwork,
  faEllipsisH, faCheck, faSync, faTimesCircle, faShare,
  faFileUpload, faRedo, faVial,
  faQuestionCircle, faQuestion, faMobileAlt, faPlusSquare, faCodeMerge,
  faTrashAlt);

Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.component('ctk-datetime', McDatetime);
Vue.component('v-offline', VOffline);
Vue.use(VueFormWizard);
Vue.use(IdleVue, {
  eventEmitter: eventsHub,
  store,
  idleTime: 130 * 60 * 1000,
  startAtIdle: false
});

componentRegistry.registerAll();

Vue.config.productionTip = false;

// Install Vue extensions
Vue.use(BootstrapVue);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');

window.addEventListener("beforeunload", async () => { await countHub.stopSignalRAsync(); });
